export default __webpack_public_path__ + "static/media/help-center.3e81a58a.png";